import { Box, Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SuggestedOrderIcon from '../../assets/icons/suggested_order.svg?react';
import KheopsIcon from '../../assets/logo/kheops-logo-icon.svg?react';

interface OrderSuggestionChipProps {
  short?: boolean;
  isKheopsSuggestion?: boolean;
}

export default function OrderSuggestionChip({ short, isKheopsSuggestion }: OrderSuggestionChipProps): React.JSX.Element {
  const { t } = useTranslation(['order']);

  const label = isKheopsSuggestion ? t('order:kheops_suggestion') : t('order:supplier_suggestion');
  const Icon = isKheopsSuggestion ? KheopsIcon : SuggestedOrderIcon;

  if (!short) {
    return (
      <Tooltip title={label}>
        <Chip
          variant="tag"
          label={label}
          icon={<Icon />}
        />
      </Tooltip>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: 0.5,
      }}
    >
      <Icon width={18} height={18} />
    </Box>
  );
}
